import { render, staticRenderFns } from "./ComponentMgmtTable.vue?vue&type=template&id=2bf09ea8"
import script from "./ComponentMgmtTable.vue?vue&type=script&lang=js"
export * from "./ComponentMgmtTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports